import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import PapersSection from "@/components/PapersSection";

export default function PaperPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Hero />
      <PapersSection />
      <Footer />
    </div>
  );
}